const state = {
  all: [],
  producao: {},
  desempenho: {},
  desempenhos: {},
  tag: {},
  tabela: {},
  dados: [],
  tabeladesempenho: {}
}

const mutations = {
  fillDataRelatorio (state, res) {
    state.producao = res.data
  },
  fillDataTag (state, res) {
    state.tabeladesempenho = res.data.tabela
    state.desempenhos = res.data.desempenho
    state.dados = res.data.dados
  },
  fillDataRelatorioTag (state, res) {
    state.tag = res.data.grafico
    state.tabela = res.data.tabela
  },
  fillDataRelatorioPedidosTempo (state, res) {
    state.desempenho = res.data.grafico
    state.tabeladesempenho = res.data.tabela
    state.desempenhos = res.data.desempenho
  }
}

const actions = {
  createRelatorioProducao(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/producao', data).then((res) => {
      context.commit('fillDataRelatorio', res)
      return res
    })
  },
  createRelatorioProducaoTag(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/producao/tag', data).then((res) => {
      context.commit('fillDataRelatorioTag', res)
      return res
    })
  },
  createRelatorioTag(context, data) {
    let qs = require('querystring')
    console.log(data)
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/desempenho/tag', data).then((res) => {
      context.commit('fillDataTag', res)
      return res
    })
  },
  createRelatorioProducaoPedidosTempo(context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v2/relatorios/desempenho', data).then((res) => {
      context.commit('fillDataRelatorioPedidosTempo', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js